import React, { useEffect, useMemo, useState } from "react";
import { Page, SubmitButton, required, FormGroup, DatePicker } from "components/common";
import { Control, actions } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";
import { Row, Col, Label, Badge } from "reactstrap";
import Select from "react-select";
import moment from "moment";
import BackButton from "../../../../components/refactoring/BackButton"
import { Trans } from "react-i18next";
import InputFile from "components/common/InputFile";
import { HistoryAndNotes } from "components"
export const TranslateTypes = (types, t) => {
  for (let type of types) {
    if (type['value'] === "Iqama") {
      type['label'] = t("Iqama")
    }
    else if (type['value'] === "Contract") {
      type['label'] = t("Contract")
    }
  }
  return types
}
export const HolidayEdit = ({
  payroll,
  t,
  url = "employee_holidays",
  model = "local",
  history,
  match,
  client,
}) => {
  const { id } = match.params;
  const { dispatch, setValue, Form, save, loaded, load, getTitle, value } = useForm({
    model,
  });

  const typeOptions = useMemo(
    () => [
      { 
        label: t("Morning"),
        value: "Morning",
      },
      {
        label: t("Afternoon"),
        value: "Afternoon",
      },
    ],
    [t]
  );

  const [employees, setEmployees] = useState([]);
  const [activeEmployees, setActiveEmployees] = useState([]);
  const [replacementEmployees, setReplacementEmployees] = useState([]);
  const [types, setTypes] = useState([]);
  const [accrued, setAccrued] = useState(null)
  const [initialReplacement, setInitialReplacement] = useState();

  const dataToOptions = (data) => {
    return data.map((x) => ({
      label: x.full_name,
      value: x.id,
    }));
  };

  const loadItems = (client, url) => client.get(`${url}`).get("data");

  useEffect(
    () =>
      void (async () => {
        const today = moment();

        const [item, employees, types] = await Promise.all([
          load(payroll, url, id, {
            starting: today.format("YYYY-MM-DD"),
            ending: today.format("YYYY-MM-DD"),
            starting_time: "Morning",
            ending_time: "Afternoon",
            reason: "",
            admin_reason: "",
            non_paid:false
          }),
          loadItems(payroll, "employees?status=Active&include_all=false"),
          loadItems(payroll, "employee_holidays/types"),
        ]);

        const allEmployees = dataToOptions(employees);
        const activeEmployees = dataToOptions(employees);

        setEmployees(allEmployees);
        setActiveEmployees(activeEmployees)
        setTypes(types);
        setValue(item);        
        setInitialReplacement(item.replacement_employee);       
        setReplacementEmployees(activeEmployees?.filter(emp => emp.value !== item.employee))
      })(),
    [id]
  );

  useEffect(() => {
    if(value.employee){
      getHolidaysData(value.employee)
    }
  }, [value.employee])

  const filterReplacementEmployees = e => {
    setReplacementEmployees(activeEmployees?.filter(item => item.value !== e))
  }
  
  async function onSubmit(item) {
    if (item.replacement_employee === initialReplacement) {
      let {replacement_employee, replacement_employee__full_name, ...xitem} = item
      item = xitem
    }

    try {
      await save(payroll, url, item);
      NotificationManager.success(t("Saved successfully"));
      history.replaceUp();
    } finally {
      dispatch(actions.setPending(model, false));
    }
  }


  function getHolidaysData(value) {
    if (value && Number.isInteger(value)) {
      loadItems(payroll, `employee_holidays/single/${value}`).then((resp) => {
        setAccrued(resp)
      })
    }
    return value
  }

  if (!loaded) return null;

  return (
    <Page title={getTitle(id, "Time Off Entry")}>
      <BackButton />
      {accrued &&
        <div className="accrued">
          <Badge color="warning" pill className="py-2" style={{fontSize:"0.7rem"}}> <Trans>Balance</Trans><span className="font-weight-bold">({accrued.current_balance})</span></Badge>
        </div>
      }
      <Form
        onSubmit={onSubmit}
        validators={{
          employee: { required },
          starting: { required },
          ending: { required },
          starting_time: { required },
          ending_time: { required },
          reason: { required },
        }} 
      >
        <Row>
          <Col>
            <FormGroup className="pb-2 pt-2"
              label="Employee *"
              model=".employee"
              addControlClass={false}
            >
              <Control.text style={{ backgroundColor: '#F4F7FE' }}
                model=".employee"
                component={Select}
                options={employees}
                simpleValue
                clearable={false}
                onChange={filterReplacementEmployees}
                disabled={!!value?.approved}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup label="Type *" model=".type" addControlClass={false} className="pb-2 pt-2">
              <Control.text style={{ backgroundColor: '#F4F7FE' }}
                model=".type"
                component={Select}
                options={types.map(type => ({ ...type, label: t(type.value) }))}
                simpleValue
                clearable={false}
                disabled={!!value?.approved}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col>
            <FormGroup label="Starting *" model=".starting" className="pb-2 pt-2">
              {/* <Input type="date" className="form-control" model=".starting" /> */}
              <DatePicker type="date" className="form-control" model=".starting" disabled={!!value?.approved}/>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup className="pb-2 pt-2"
              label="Starting Time *"
              model=".starting_time"
              addControlClass={false}
            >
              <Control.text
                model=".starting_time" style={{ backgroundColor: '#F4F7FE' }}
                component={Select}
                options={typeOptions}
                simpleValue
                clearable={false}
                searchable={false}
                disabled={!!value?.approved}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup label="Ending *" model=".ending" className="pb-2 pt-2">
              {/* <Input type="date" className="form-control" model=".ending" /> */}
              <DatePicker type="date" className="form-control" model=".ending" disabled={!!value?.approved}/>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup
              label="Ending Time *"
              model=".ending_time"
              addControlClass={false} className="pb-2 pt-2"
            >
              <Control.text
                model=".ending_time" style={{ backgroundColor: '#F4F7FE' }}
                component={Select}
                options={typeOptions}
                simpleValue
                clearable={false}
                searchable={false}
                disabled={!!value?.approved}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup className="pb-2 pt-2"
              label="Replacement Employee"
              model=".replacement_employee"
              addControlClass={false}
            >
              <Control.text style={{ backgroundColor: '#F4F7FE' }}
                model=".replacement_employee"
                component={Select}
                options={replacementEmployees}
                simpleValue
                clearable={true}
                disabled={!!value?.approved}
              />
            </FormGroup>
          </Col>

          <Col>
          </Col>
        </Row>

        <Row className="align-items-center">
          <Col className="col-6">
            <div className="form-group form-check">
              <Control.checkbox model=".non_paid" className="form-check-input"  />
              <Label className="form-check-label" htmlFor=".non_paid" defaultValue={false} disabled={!!value?.approved}><Trans>Non Paid Holiday</Trans></Label>
            </div>
          </Col>
        </Row>
        <FormGroup label="Reason *" model=".reason" className="pb-2 pt-2">
          <Control.textarea rows="4" model=".reason" updateOn="blur" style={{ backgroundColor: '#F4F7FE' }} disabled={!!value?.approved}/>
        </FormGroup>
        <FormGroup label="Approval Note" model=".admin_reason" className="pb-2 pt-2">
          <Control.textarea rows="4" model=".admin_reason" updateOn="blur" style={{ backgroundColor: '#F4F7FE' }} disabled={!!value?.approved}/>
        </FormGroup> 
        <FormGroup className="pb-2 pt-3">
          <label htmlFor=""><Trans>Attachment</Trans></label>
          <InputFile t={t} file={value.attachment||""} setData={setValue} disabled={!!value?.approved}></InputFile>
        </FormGroup>
        <div className="d-flex justify-content-between my-2">
          <SubmitButton
            color="danger"
            onClick={() => {
              dispatch(actions.change("local.approved", false));
              dispatch(actions.submit("local"));
            }} 
            disabled={value && value.approved} 
            >
            Reject
          </SubmitButton>
          <SubmitButton
            disabled={!!value?.approved}
            onClick={() => {
              dispatch(actions.change("local.approved", true));
              dispatch(actions.submit("local"));
            }}
            // disabled={id !== "new" && value && value.approved} 
            >
            Approve
          </SubmitButton>
        </div>
      </Form>

      <hr />

      <HistoryAndNotes
        item={value}
        contentType={'employeeholidayrequest'}
        client={client}
        t={t}
      />
    </Page>
  );
};

export default HolidayEdit;
